import React, { useState } from "react";

import { useSearchDatasetsUsage } from "api/api-hooks/datasets-hooks";
import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import { TabPanel, TabPanelHeaderTemplateOptions, TabView } from "primereact/tabview";
import { T } from "services/lang/LanguageService";
import { Badge } from "primereact/badge";
import DashboardResultTable from "./DashboardResultTable";
import TaskResultTable from "./TaskResultTable";

const DatasetUsageSearch: React.FC = () => {
  const [identifier, setIdentifier] = useState<string | null>(null);

  const { data, isLoading } = useSearchDatasetsUsage([identifier!], {
    enabled: !!identifier,
  });

  const taskResultData = data?.filter(item => !!item.task) ?? [];
  const dashboardResultData = data?.filter(item => !!item.dashboard) ?? [];

  const tabHeaderTemplate = (options: TabPanelHeaderTemplateOptions, count: number) => (
    <div className="p-tabview-nav-link p-3" onClick={options.onClick} role="tab" tabIndex={0}>
      <span className="p-tabview-title">{options.titleElement}</span>
      <Badge value={count} className="ml-2" />
    </div>
  );

  return (
    <div className="flex flex-column gap-5">
      <div className="flex flex-column gap-1">
        <label htmlFor="identifier">{T("word.identifier")}</label>
        <DatasetDropdown value={identifier} onChange={val => setIdentifier(val)} />
      </div>
      <TabView className="col-12">
        <TabPanel
          header={T("word.dashboards")}
          headerTemplate={options => tabHeaderTemplate(options, dashboardResultData.length)}
        >
          <DashboardResultTable results={dashboardResultData} loading={isLoading} />
        </TabPanel>
        <TabPanel
          header={T("word.tasks")}
          headerTemplate={options => tabHeaderTemplate(options, taskResultData.length)}
        >
          <TaskResultTable results={taskResultData} loading={isLoading} />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default DatasetUsageSearch;
